import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

// Slide up animation styles
const slideUpStyles = `
  @keyframes slideUpNotification {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const AddNotificationModal = ({
  isOpen,
  handleClose,
  handleSaveNotification,
  children,
  handleAPICall,
}) => {
  const [swipe, setSwipe] = useState({ startY: 0, currentY: 0, isDragging: false });

  const swipeOffset = Math.max(0, swipe.currentY - swipe.startY);

    const isMobileView = document.body.clientWidth <= 768;

  if (!isOpen) return null;

  return (
    <>
      <style>{slideUpStyles}</style>
      <div
        className={`fixed z-50 inset-0 overflow-y-auto flex ${isMobileView ? 'items-end' : 'items-center'} justify-center bg-black/70`}
        onClick={handleClose}
      >
        <div
          className="bg-white rounded-2xl w-full max-w-lg p-6 shadow-xl"
          onClick={(e) => e.stopPropagation()}
          style={
            isMobileView
              ? {
                  animation: swipe.isDragging ? 'none' : 'slideUpNotification 0.3s ease-out',
                  transform: `translateY(${swipeOffset}px)`,
                  transition: swipe.isDragging ? 'none' : 'transform 0.3s ease-out',
                }
              : {}
          }
        >
          {/* Handle bar - draggable to close */}

          {isMobileView && (
          <div
            className="flex justify-center mb-3 cursor-grab py-1 -mt-2"
            onTouchStart={(e) => {
              e.stopPropagation();
              setSwipe({ startY: e.touches[0].clientY, currentY: e.touches[0].clientY, isDragging: true });
            }}
            onTouchMove={(e) => {
              e.stopPropagation();
              if (swipe.isDragging) {
                setSwipe((prev) => ({ ...prev, currentY: e.touches[0].clientY }));
              }
            }}
            onTouchEnd={(e) => {
              e.stopPropagation();
              if (swipe.currentY - swipe.startY > 30) {
                handleClose();
              }
              setSwipe({ startY: 0, currentY: 0, isDragging: false });
            }}
          >
            <div className="w-10 h-1 bg-gray-600 rounded-full"></div>
          </div>
          )}

          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-bold text-primaryColor">
              Add Notifications
            </h2>
            <span className="cursor-pointer text-gray-500 hover:text-gray-700" onClick={handleClose}>
              <FontAwesomeIcon icon={faClose} className="w-5 h-5" />
            </span>
          </div>
          {children}
          <div className="flex items-center justify-center mt-4">
            <button
              className="w-full bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline"
              onClick={handleAPICall}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNotificationModal;
